import styled from "styled-components";

import { constants } from "@layout";

export const Container = styled.div`
  min-width: 320px;
  max-width: 375px;
  padding: ${constants.divPadding}px;
`;
